// extracted by mini-css-extract-plugin
export default {"MainCont":"Proofing_MainCont__X3FEd","LeftCont":"Proofing_LeftCont__sZZDN","RightCont":"Proofing_RightCont__42Noj"};